<!-- <p>organisation-flagged-assets works!</p> -->
<!-- <p>user-favourites works!</p> -->

<div class="user-favourites">
    @if (selectedOrganisation) {
    <span style="font-size: large; font-weight: bolder;">{{ selectedOrganisation.Name }}
        Flagged Assets</span>
    }
    <div class="middle-div alignRow">
        <span class="toolbar-spacer"></span>
        <div class="location-dropdown">
            <ejs-dropdownlist id="locationDropdown" #locationDropdown [dataSource]='dropdownLocations'
                placeholder="Select Location" [fields]="dropdownLocationFields"
                (change)="onQueryParameterChange('Location',$event)" [allowFiltering]="true"
                [(ngModel)]="this.filterQueryParams.Location" filterType="contains" [showClearButton]="true">
                <ng-template #itemTemplate let-data>
                    <div>
                        <span>{{data.Name}}</span>
                    </div>
                </ng-template>
            </ejs-dropdownlist>
        </div>
    </div>
    <mat-form-field>
        <mat-label>Search for an Asset</mat-label>
        <input matInput (keyup)="onQueryParameterChange('Filter', $event)" placeholder="" #input
            [(ngModel)]="filterQueryParams.Filter">
    </mat-form-field>
    <ng-template #LoadingAssets>
        <div class="waiting-container">
            <div class="item">
                <h2>Loading Flagged Assets</h2>
            </div>
        </div>
    </ng-template>
    <ng-container *ngIf="FavouriteAssets && dataSourceAssets else LoadingAssets">
        @if (dataSourceAssets) {
        <table mat-table matSort #tableAssets #sortAssets="matSort" [dataSource]="dataSourceAssets"
            (matSortChange)="onQueryParameterChange('SortColumn',$event)">
            <ng-container matColumnDef="Image">
                <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                <td style="font-weight: bolder;" mat-cell *matCellDef="let row">
                    <img class="assetImage" src="{{imagePathAssets()}}{{row.AssetID}}?{{row.Modified}}"
                        style="max-height: 50px; max-width: 50px;"
                        onerror="this.src='https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/noimage.png'"
                        (click)='viewImage(imagePathAssets() + row.AssetID + "?" + row.Modified)'
                        [attr.x-contenttype]="'image/png'" />
                </td>
            </ng-container>
            <ng-container matColumnDef="Name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
                <td mat-cell *matCellDef="let row">
                    {{row.Name}} </td>
            </ng-container>
            <ng-container matColumnDef="AddedByName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Added By</th>
                <td mat-cell *matCellDef="let row">
                    {{row.AddedByName }}
                </td>
            </ng-container>
            <ng-container matColumnDef="Comment">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Comment</th>
                <td mat-cell *matCellDef="let row">
                    {{row.Comment}}
                </td>
            </ng-container>
            <ng-container matColumnDef="HierarchyPath">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Location</th>
                <td mat-cell *matCellDef="let row">
                    {{row.HierarchyPath}}
                </td>
            </ng-container>
            <ng-container matColumnDef="AddedAt">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Flagged At</th>
                <td mat-cell *matCellDef="let row">
                    <span>{{convertEpoch(row.AddedAt)}}</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="GoToAsset">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let row">
                    <button mat-raised-button color="primary" (click)="goToAsset(row)" class="app-icon--goto">
                        <span>Go To Asset</span>
                        <mat-icon />
                    </button>
                </td>
            </ng-container>

            <ng-container matColumnDef="RemoveAsset">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let row">
                    <span (click)="removeFavourite(row)" class="app-icon app-icon--flagged alignColumn"
                        matTooltip="Remove Flagged Asset">
                        <mat-icon />
                    </span>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="assetTableColumns"></tr>
            <tr mat-row class="table-row" *matRowDef="let row; columns: assetTableColumns;"></tr>
            <tr class="mat-row" *matNoDataRow>
                @if (input.value != '') {
                <td class="mat-cell" colspan="7">No Data Matching the Filter: "{{input.value}}"</td>
                } @else {
                <td class="mat-cell" colspan="7">No Data Matching the Filter</td>
                }
            </tr>
        </table>
        <mat-paginator #paginatorAssets [pageSizeOptions]="[10, 15, 20, 25, 50]"
            [pageSize]="filterQueryParams.pageSize ?? 10" [pageIndex]="filterQueryParams.pageIndex"
            (page)="onPageChange(paginatorAssets, $event)" aria-label="Select page of assets"></mat-paginator>
        }
    </ng-container>

</div>